import React from 'react';
import './styles.less';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { InfoIcon } from '../../../../components/info-icon';
import { thousandSeparator } from '../../../reqs-filter/utils';

const CustomCell = ({ field, row }) => {
	if (field === 'id') {
		return (
			<div className="custom-cell-process__id">
				<InfoIcon popupContent={`№ ${row[field]}`} link={row.link} />
			</div>
		);
	}

	if (field === 'orders_sum_weight' && row.process && !row.planning) {
		return `${row.plannings_process}/${row.plannings_total}`;
	}

	if (field === 'orders_sum_volume' && row.process && !row.planning) {
		return (
			<div className="custom-cell-process__process">
				<div className={`status-indicator status-indicator_${row.process_status}`} />
				<Link className="custom-cell-process__link" to={row.link_process}>
					Подробнее
				</Link>
			</div>
		);
	}

	if (field === 'address_from' && row.address_from) {
		return (
			<Link className="custom-cell__link" to={row.address_from.link}>
				{row.address_from.address}
			</Link>
		);
	}

	if (field === 'address_to' && row.address_to) {
		return (
			<Link className="custom-cell__link" to={row.address_to.link}>
				{row.address_to.address}
			</Link>
		);
	}

	if (field === 'cost' && row.cost) {
		return `${thousandSeparator(row.cost)} руб`;
	}

	if (field === 'orders_sum_cost' && row.orders_sum_cost) {
		return `${thousandSeparator(row.orders_sum_cost)} руб`;
	}

	if (field === 'orders_sum_weight' && row.orders_sum_weight_with_rate) {
		return `${row.orders_sum_weight_with_rate}/${row.weight_with_recycling ?? ''}`;
	}

	if (field === 'orders_sum_volume' && row.orders_sum_volume_with_rate) {
		return `${row.orders_sum_volume_with_rate}/${row.volume_with_recycling ?? ''}`;
	}

	return row[field];
};

CustomCell.propTypes = {
	row: PropTypes.object.isRequired,
	field: PropTypes.string.isRequired,
};

export { CustomCell };
